import PLAT from './config_platform.js'
import ACTIVE from './config_active.js'
import DOCT from './config_doct.js'
import PLAN from './confing_medicationPlan.js'
export const ActiveLable = {
  0: {
    baseLabel: PLAT.BASE_LABEL,
    visitLabel: PLAT.visitDateColumn,
    baseLabel_plan: PLAN.BASE_LABEL,
    visitLabel_plan: PLAN.visitDateColumn
  },
  1: {
    baseLabel: ACTIVE.BASE_LABEL,
    visitLabel: ACTIVE.visitDateColumn
  },
  2: {
    baseLabel: DOCT.BASE_LABEL,
    visitLabel: DOCT.visitDateColumn
  }
}
export const relatedColumns = [
  {
    label: '关联内容',
    prop: 'relatedContent'
  },
  {
    label: '填写状态',
    prop: 'commitFlag'
  },
  {
    label: '提交时间',
    prop: 'commitTime'
  }
]
export const flowResultStatusList = [
  { label: '很好', value: 1 },
  { label: '良好', value: 2 },
  { label: '一般', value: 3 },
  { label: '不好', value: 4 },
  { label: '无回复', value: 5 }
]
